module.exports = __webpack_public_path__ + "files/4b602aa0b793ef9ae6233b995d00a736.png";